/**
 * The lockup: the mark, and the wordmark beside it.
 *
 * The mark is `public/icon.svg` by `<img>` rather than inline SVG, so the
 * artwork exists exactly once -- the same file the PNG icons are rasterised
 * from (`scripts/make-icons.mjs`) and the same one the browser tab and the
 * installed app use. Inlining it would make a second copy that could drift.
 *
 * `size` is the identity's two lockups: "sm" is the primary horizontal one in
 * the top bar, "lg" is the stacked one the sign-in screen leads with.
 *
 * `stock` adds utucat stock's mark after the wordmark: the same product,
 * wider, not a second app -- so it is a tag on the name, in the stock accent,
 * not a new logo.
 */
export function Logo({
  size = "sm",
  withWord = true,
  stock = false,
}: {
  size?: "sm" | "lg";
  withWord?: boolean;
  stock?: boolean;
}) {
  return (
    <span className={size === "lg" ? "lockup lockup-lg" : "lockup"}>
      {/* Decorative: the wordmark beside it already says the name, and where it
          does not (withWord={false}) the button around it carries the label. */}
      <img
        className="lockup-mark"
        src="/icon.svg"
        alt=""
        width={size === "lg" ? 56 : 28}
        height={size === "lg" ? 56 : 28}
      />
      {withWord && <span className="lockup-word">utucat</span>}
      {withWord && stock && <span className="lockup-stock">stock</span>}
    </span>
  );
}
